import React from 'react';
import { Typography } from '@mui/material';
import { Button } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import useSwalWrapper from "@jumbo/vendors/sweetalert2/hooks";
import { postApiOrThrow } from '../utils/apiFunction';

const DeleteCurrentRun = (props) => {
    const Swal = useSwalWrapper();
    const [loading, setLoading] = React.useState(false);
    const [error, setError] = React.useState(false);
    const validate = () => {
        const completed = !!props.selectedBench?.finish;
        Swal.fire({
            html: completed
                ? 'This will reverse the input and outputs in inventory and MYOB. The process record will be retained for audit purposes.'
                : 'This will reverse the input and any outputs, then remove the run from the Daily Plan.',
            icon: 'warning',
            title: '',
            showCancelButton: true,
            confirmButtonText: 'Yes, Continue',
            cancelButtonText: 'No, Go Back',
        }).then(result => {
            if (result.value) {
                submit();
            }
        });
    }

    const submit = async () => {
        setError(false);
        setLoading(true);
        try {
            await postApiOrThrow('/Processing/DeleteProcessRun', {
                ProcessRunId: props.selectedBench?.id,
            });
            props.handleClose();
            return;
        } catch (submitError) {
            setError(submitError?.message || "Failed to submit");
        }
        setLoading(false);
    }
    return <React.Fragment>
    <Typography variant={'h5'}>Are you sure you want to delete {props.selectedBench?.mixedGroupId ? 'this mixed group' : 'this run'}?</Typography>
    {error ? <Typography color="error">{error}</Typography> : null}
    {loading ? <CircularProgress /> : <Button variant="contained" color="error" style={{ whiteSpace: 'nowrap', height: '50px', margin: 0 }} onClick={validate} >DELETE</Button>}

    </React.Fragment>
}
export default DeleteCurrentRun;